module.exports = __webpack_public_path__ + "img/btn-bind.11336352.png";